import Service from '@/service/index.js';
export default {
  props: ['item', 'index', 'transferType', 'projectSubType', 'needtoShow'],
  data() {
    return {
      massifTypeArr: []
    };
  },
  created() {
    Service.getSelectList('PROJECT_TYPE').then(({ code, data }) => {
      if (code === '0') {
        let tempList = data.find(item => item.code === '4');
        if(tempList) {
          this.massifTypeArr = tempList.list;
        }
      }
    });
  }
};

